<template>
  <v-footer :fixed="fixed" app>
    <span style="margin:10px;">&copy;{{new Date().getFullYear()}} GoPear Technologies</span>
  </v-footer>
</template>

<script>
export default {
  data () {
    return {
      fixed: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PageFooter.vue